import type { GetServerSidePropsContext } from 'next';

import type { AppStore } from 'redux-store';
import getProfileThunk from 'redux-store/thunks/profile/getProfileThunk';

export class ProfileService {
  async getProfile(
    { store }: { store: AppStore },
    context: GetServerSidePropsContext,
  ): Promise<void> {
    await store.dispatch(getProfileThunk(context));
  }
}

export const profileService = new ProfileService();
